<template>
  <Tigan :topic="topic" :index="index">
    <div>
      <div class="tigan-html" v-html="topic.tiGan.html" />
      <AudioPlay ref="audioPlay" :audios="topic.audios" />
    </div>
    <div class="topic-extra" v-if="topic.yinbiaos && topic.yinbiaos.length">
      <div class="extra-title">
        音标：
      </div>
      <div v-html="topic.yinbiaos[0].html" />
    </div>
    <div class="topic-extra" v-if="topic.shiyis && topic.shiyis.length">
      <div class="extra-title">
        释义：
      </div>
      <div v-html="topic.shiyis[0].html" />
    </div>
    <div class="topic-img" v-if="topic.images && topic.images.length">
      <div class="img-item" v-for="(item, index) in topic.images" :key="index" v-html="item.html" />
    </div>
  </Tigan>
</template>
<script>
import AudioPlay from './AudioPlay.vue'
import Tigan from './Tigan.vue'
export default {
  components: {
    AudioPlay,
    Tigan
  },
  props: {
    topic: Object,
    index: Number
  }
}
</script>
<style lang="less" scoped>
.topic-box {
  padding: 12px 14px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.tigan-html {
  display: inline-block;
  margin-right: 4px;
  line-height: 22px !important;
}
.topic-extra {
  display: flex;
  margin-top: 4px;
  .extra-title {
    font-weight: 700;
  }
}
.topic-img {
  margin-top: 12px;
  :deep(img) {
    width: auto !important;
    height: 92px !important;
  }
  .img-item {
    display: inline-block;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>